import { Expose } from 'class-transformer';

export class CurrentForecast {
  @Expose()
  description: string;

  @Expose({ name: 'icon_url' })
  icon: string;

  @Expose({ name: 'magnetic_field' })
  magneticField: number;

  @Expose()
  precipitation: number;

  @Expose({ name: 'icon_url' })
  pressure: number;

  @Expose({ name: 'relative_humidity' })
  relativeHumidity: number;

  @Expose()
  temperature: number;

  @Expose({ name: 'water_temperature' })
  waterTemperature?: number;

  @Expose({ name: 'wind_temperature' })
  windTemperature: number;

  @Expose({ name: 'wind_degrees' })
  windDegrees: number;

  @Expose({ name: 'wind_direction' })
  windDirection: string;

  @Expose({ name: 'wind_speed' })
  windSpeed: number;

  @Expose({ name: 'sunrise_time' })
  sunriseTime: string;

  @Expose({ name: 'sunset_time' })
  sunsetTime: string;

  @Expose({ name: 'wind_speed_abnormal' })
  isWindSpeedAbnormal: boolean;

  @Expose({ name: 'precipitation_abnormal' })
  isPrecipitationAbnormal: boolean;
}
